import { WithIconTextareaFormInput } from "../generic/forms/withIconTextAreaFormInput";
import { SvgEnvelop } from "../../assets/icons";
import { SvgKey } from "../../assets/icons";

export const LoginForm = () => {
  return (
    <div className="d-flex flex-column align-items-center">
      <WithIconTextareaFormInput
        className="ms-2 p-0 w-100 me-2 mt-3"
        name="userId"
        placeholder="Email"
        svgicon={SvgEnvelop}
      />
      <WithIconTextareaFormInput
        className="ms-2 p-0 w-100 me-2 mt-3"
        name="password"
        placeholder="Password"
        svgicon={SvgKey}
        type="password"
      />
    </div>
  );
};
